export default __webpack_public_path__ + "img/caret-down.09d9833f.svg";